import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

function HandShake() {
    return (
        <StaticImage
            src="../../images/HandShake.jpg"
            alt="Two hands shaking"
            placeholder="blurred"
            layout="constrained"
        />
    );
}

export default HandShake;
